import { h, Component } from 'preact'
import ProjectsAPI from '../api/ProjectsAPI'
import Projects from '../components/Projects'
import LoadMoreProjects from '../components/LoadMoreProjects'
import MarketFilter from './MarketFilter'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {
  constructor(props) {
    super(props)

    // check if href hash exists and is an integer
    const hashMarket = location.hash && Number.isInteger(parseInt(location.hash.substr(1)))
      ? location.hash.substr(1)
      : ''
    const count = window.innerWidth < 1280 ? 8 : 9
    // Filled here, not in componentDidMount, so the first render matches the server HTML it hydrates
    const initial = hashMarket ? null : this.initialProjects()
    // Server sends 9; cut to count so the offset for "load more" matches what is shown
    const projects = initial ? initial.projects.slice(0, count) : []

    this.state = {
      projects: projects,
      count: count,
      offset: 0,
      currentMarket: hashMarket,
      totalAmountProjects: initial ? initial.total : null,
      loadedAllProjects: initial ? initial.total == projects.length : false,
      isLoading: !initial,
      imagesReady: false,
      error: false
    }

    this.handleLoadMore = this.handleLoadMore.bind(this)
    this.handleMarketChoice = this.handleMarketChoice.bind(this)
  }

  componentDidMount() {
    if (this.state.isLoading) {
      this.fetchProjects()
    }

    // The other card images would share the connection with the LCP image, so they wait until it is
    // painted: Lighthouse counts every request that starts before the LCP paint, which comes after decode
    const first = this.base && this.base.querySelector('.c-project__background')
    if (!first) {
      this.setState({ imagesReady: true })
      return
    }

    let shown = false
    const showImages = () => {
      if (!shown) {
        shown = true
        this.setState({ imagesReady: true })
      }
    }

    // Fallback for browsers without the LCP API (Safari) and for pages where another element is the LCP
    const afterLoad = () => setTimeout(showImages, 1000)
    if (first.complete) {
      afterLoad()
    } else {
      first.addEventListener('load', afterLoad, { once: true })
      first.addEventListener('error', showImages, { once: true })
    }

    const types = window.PerformanceObserver && PerformanceObserver.supportedEntryTypes
    if (types && types.indexOf('largest-contentful-paint') !== -1) {
      new PerformanceObserver((list, observer) => {
        if (list.getEntries().some(entry => entry.element === first)) {
          observer.disconnect()
          showImages()
        }
      }).observe({ type: 'largest-contentful-paint', buffered: true })
    }
  }

  initialProjects() {
    const el = document.getElementById('js-projects-initial')
    if (!el) return null

    try {
      return JSON.parse(el.textContent)
    } catch (e) {
      return null
    }
  }

  fetchProjects() {
    this.setState({ isLoading: true })

    ProjectsAPI.all(this.state, this.props.sub_id)
      .then(response => {
        this.setState({
          totalAmountProjects: response.headers.get('x-wp-total')
        })
        return response.json()
      })
      .then(data => {
        this.setState({
          projects: [...this.state.projects, ...data],
          loadedAllProjects: false,
          isLoading: false
        })
        this.verifyLoadedAllPosts()
      })
      .catch(error => {
        this.setState({
          error: true,
          isLoading: false
        })
      })
  }

  verifyLoadedAllPosts() {
    if (this.state.totalAmountProjects == this.state.projects.length) {
      return this.setState({
        loadedAllProjects: true
      })
    }

    return false
  }

  handleLoadMore() {
    this.setState(prevState => {
      return {
        offset: prevState.offset + this.state.count
      }
    }, this.fetchProjects)
  }

  handleMarketChoice(value) {
    this.setState(() => {
      return {
        currentMarket: value,
        projects: [],
        offset: 0
      }
    }, this.fetchProjects)
  }

  render() {
    return (
      <div className="c-projects-app">
        <Projects
          projects={this.state.projects}
          loading={this.state.isLoading}
          error={this.state.error}
          language={this.props.language}
          imagesReady={this.state.imagesReady}
        />

        <LoadMoreProjects
          onLoadMore={this.handleLoadMore}
          nrShowing={this.state.projects.length}
          nrAll={this.state.totalAmountProjects}
          loading={this.state.isLoading}
          language={this.props.language}
        />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/projects/containers/App.js